import blablacar from '../images/companies/logoBlablacar.png';
import blablabus from '../images/companies/logoBusBlablacar.png';
import eurolines from '../images/companies/logoEurolines.png';
import flixbus from '../images/companies/logoFlixbus.png';
import inoui from '../images/companies/logoInoui.png';
import ouibus from '../images/companies/logoOuibus.png';
import ouigo from '../images/companies/logoOuigo.png';
import sncf from '../images/companies/logoSNCF.png';
import ter from '../images/companies/logoTER.png';
import thalys from '../images/companies/logoThalys.png';
import altibus from '../images/providers/logo_altibus.png';
import eurostar from '../images/providers/logo_eurostar.svg';
import trenitalia from '../images/providers/logo_trenitalia.svg';

const stringEqual = (str1, str2) =>
  str1.localeCompare(str2, undefined, {
    sensitivity: 'base',
  }) === 0;

export const getCompanyLogo = (companyName) => {
  const filteredCompanies = homePageCompanies.filter((company) =>
    stringEqual(company.name, companyName),
  );
  if (filteredCompanies[0]) return filteredCompanies[0].logo;
  return null;
};

export const getProviderById = (id) => providers[id];

const homePageCompanies = [
  {
    id: 0,
    databaseId: 10,
    name: 'SNCF',
    logo: sncf,
    url: '/company/train/sncf',
    openInNewTab: false,
    isVisible: true,
  },
  {
    id: 1,
    databaseId: 13,
    name: 'Ouigo',
    logo: ouigo,
    url: '/company/train/sncf/ouigo',
    openInNewTab: false,
    isVisible: true,
  },
  {
    id: 2,
    databaseId: 5,
    name: 'Flixbus',
    logo: flixbus,
    url: '/company/bus/flixbus',
    openInNewTab: false,
    isVisible: true,
  },
  {
    id: 3,
    databaseId: 11,
    name: 'Blablacar',
    logo: blablacar,
    url: '/company/carpooling/blablacar',
    openInNewTab: false,
    isVisible: true,
  },
  {
    id: 4,
    name: 'inOui',
    logo: inoui,
    url: '/company/train/sncf/inoui',
    openInNewTab: false,
  },
  {
    id: 5,
    name: 'trenitalia',
    logo: trenitalia,
    url: '/company/train/trenitalia',
    openInNewTab: false,
  },
  {
    id: 6,
    name: 'eurostar',
    logo: eurostar,
    url: '/company/train/eurostar',
    openInNewTab: false,
  },
  {
    id: 7,
    name: 'Bus Blablacar',
    logo: blablabus,
    url: '/company/carpooling/blablacar/blablabus',
    openInNewTab: false,
    isVisible: true,
  },
  {
    id: 8,
    name: 'Altibus',
    logo: altibus,
    url: null,
    openInNewTab: false,
    isVisible: true,
  },
];

const providers = {
  1: { name: 'Ouibus', logo: ouibus, url: 'companies/ouibus' },
  2: { name: 'Deinbus', logo: '', url: 'companies/' },
  4: { name: 'Student Agency', logo: '', url: 'companies/' },
  5: { name: 'Flixbus', logo: flixbus, url: 'companies/' },
  9: { name: 'Distribusion', logo: '', url: 'companies/' },
  10: { name: 'SNCF', logo: sncf, url: 'companies/' },
  11: { name: 'Blablacar', logo: blablacar, url: 'companies/' },
  12: { name: 'iDVROOM', logo: '', url: 'companies/' },
  13: { name: 'OUIGO', logo: ouigo, url: 'companies/' },
  14: { name: 'Thalys', logo: thalys, url: 'companies/' },
  16: { name: 'TER', logo: ter, url: 'companies/' },
  20: { name: 'Eurolines', logo: eurolines, url: 'companies/' },
  21: { name: 'Altibus', logo: '', url: 'companies/' },
  30: { name: 'Vatry', logo: '', url: 'companies/' },
  50: { name: 'LEOExpress', logo: '', url: 'companies/' },
  66: { name: 'ZOU!', logo: '', url: 'companies/' },
  99: { name: 'Distribusion', logo: '', url: 'companies/' },
  104: { name: 'Izy', logo: '', url: 'companies/' },
  200: { name: 'Italo Treno', logo: '', url: 'companies/' },
};
export default homePageCompanies;
